module.exports = __webpack_public_path__ + "static/media/triumph.10570f36.png";